import { Box, Typography } from "@outschool/backpack";
import { centsToDollars } from "@outschool/business-rules";
import { useTranslation } from "@outschool/localization";
import { Checkbox } from "@outschool/ui-legacy-component-library";
import { pxToRem } from "@outschool/ui-utils";
import React from "react";

type SubscriptionAuthorizationProps = {
  setIsChecked: (isChecked: boolean) => void;
  isChecked: boolean;
  isPaymentProcessing: boolean;
  isPaymentSuccessful: boolean;
  totalCents: number;
};

export default function ResumeSubscriptionsAuthorization({
  setIsChecked,
  isChecked,
  isPaymentProcessing,
  isPaymentSuccessful,
  totalCents
}: SubscriptionAuthorizationProps) {
  const { t } = useTranslation(
    "client\\components\\payments\\ResumeSubscriptionsAuthorization"
  );

  const paymentAmount = `$${centsToDollars(totalCents)} USD`;

  const disclaimerText = t(
    "I authorize Outschool, Inc. to charge my credit card {{paymentAmount}} \
    as payment for the class on a recurring basis. I acknowledge the charges \
    will automatically be charged weekly on Sunday. To remove your \
    learner from the class and stop recurring charges, please visit the \
    classroom page for the class and click on the “Stop Subscription” link.",
    {
      paymentAmount
    }
  );

  return (
    <Box
      sx={{
        backgroundColor: "grey.50",
        marginBottom: "1em",
        padding: pxToRem(16),
        borderRadius: pxToRem(8),
        width: "100%"
      }}
    >
      <Box
        flex
        sx={{
          fontSize: "0.875em"
        }}
      >
        <Checkbox
          id="disclaimer-checkbox"
          checked={isChecked}
          disabled={isPaymentProcessing || isPaymentSuccessful}
          onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
            setIsChecked(e.target.checked)
          }
        />

        <label htmlFor="disclaimer-checkbox">
          <Typography
            variant="inherit"
            component="div"
            sx={{
              marginLeft: "0.5em"
            }}
          >
            {disclaimerText}
          </Typography>
        </label>
      </Box>
    </Box>
  );
}
